module.exports = __webpack_public_path__ + "img/gas-alarm.9fe22d94.svg";